export default __webpack_public_path__ + "static/media/video-off.24beaada.svg";